import React from 'react';

const About = () => (
    <section id="header" style={{
        background: '#000',
        padding: '0 2rem',
    }}>
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
        }}>
            <div
                alt="Profile"
                className="profile-image-morph"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL + '/profile.jpg'})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '85%',
                }}
            />
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                background: '#000',
                padding: '2rem 3rem 2rem 2rem',
                borderRadius: '1rem',
                minWidth: '400px',
            }}>
                <h1 style={{ fontSize: '3rem', fontWeight: 'bold', margin: 0, color: '#fff' }}>Aidan McQueen</h1>
                <p style={{ fontSize: '1.25rem', color: '#fff', marginTop: '1rem' }}>
                    Computer Science Student | DevelopIQ Co-Founder
                </p>
            </div>
        </div>
    </section>
);

export default About; 